import React from "react";
import {
  Projects,
  AboutUs,
  Clients,
  Contact,
  Services,
  FeaturedProjects,
} from "../components";

function Home() {
  return (
    <>
      <AboutUs />
      <FeaturedProjects />
      <Projects />
      <Services />
      <Clients />
      <Contact />
    </>
  );
}

export default Home;
